import * as THREE from 'three';

import { DEFAULT_LAYER_COLOR } from '../../constants/colors.ts';
import { getLayerDisplayColor } from '../../utils/layerColorUtils.ts';
import { LayerSetting } from '../project-settings/types.ts';

// Only include meshes with meaningful names, not default/system names
export const shouldIncludeMesh = (object: THREE.Object3D): boolean => {
  // Skip empty names
  if (!object.name || object.name.trim() === '') {
    return false;
  }

  // Skip common system/default names
  const skipNames = [
    'Scene',
    'Node',
    'Mesh',
    'Animation',
    'Skin',
    'Material',
    'Default',
    'Root',
    'Object',
    'Group',
    'Empty',
  ];

  // Check if the object name exactly matches any of the skip names
  for (const skipName of skipNames) {
    if (object.name === skipName) {
      return false;
    }
  }

  // Only include THREE.Mesh objects
  return object instanceof THREE.Mesh;
};

/**
 * Returns the display color for a layer based on CHL/LMN state.
 * Falls back to gray (no random colors).
 */
export function getLayerColor(threeJsName: string, layerSettings: LayerSetting[]): string {
  const layer = layerSettings.find((setting) => setting.threeJsName === threeJsName);
  if (!layer) return DEFAULT_LAYER_COLOR;

  return getLayerDisplayColor({
    canHoldLuminaire: !!layer.canHoldLight,
    isIlluminated: !!layer.illuminated,
  });
}
